import {
  DigitalAuditComment as BaseDigitalAuditComment,
  ListCommentsResult as BaseListCommentsResult
} from '@blisspointmedia/bpm-types/dist/DigitalAudit';

export type DigitalAuditComment = BaseDigitalAuditComment;
export type ListCommentsResult = BaseListCommentsResult;

export const COMMENTS_QUERY_KEY = 'digital-audit-comments';

// Stable section keys stored with each comment - changing one orphans that
// section's existing comments, so treat these as persisted identifiers.
export const CommentAnchor = {
  DETECTED_STACK: 'audit-report.detected-stack',
  KEY_IDS: 'audit-report.key-ids',
  OBSERVATIONS: 'audit-report.observations',
  ACCESS_TO_REQUEST: 'audit-report.access-to-request',
  LOAD_SPEED: 'site-health.load-speed',
  DISCOVERABILITY: 'site-health.discoverability',
  JS_RENDERING: 'site-health.js-rendering',
  DATA_LAYER: 'pixel-intel.data-layer',
  EVENT_COVERAGE: 'pixel-intel.event-coverage',
  PARAMETER_COMPLETENESS: 'pixel-intel.parameter-completeness',
  PLATFORM_DIVERGENCE: 'pixel-intel.platform-divergence',
  DECODED_CALLS: 'pixel-intel.decoded-calls'
} as const;

export const channelAnchor = (channelId: string): string => `channel-health.${channelId}`;
export const journeyStageAnchor = (stageNum: number): string => `journey.stage-${stageNum}`;
